import useProjectDomains from "../../../../api/utilities/useProjectDomains.js";
import Spinner from "../../../../components/Spinner.jsx";
import Button from "../../../../components/Button.jsx";
import Creatable from "react-select/creatable";
import {useEffect, useMemo, useState} from "react";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectApi} from "../../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";
import {IntegrationAddButton} from "../IntegrationDetailUi.jsx";

export default function HostNameAndXmlLinkList({project, projectIntegration, value, onChange}) {
    let authorityConfiguration = useAuthorityConfiguration();

    let projectDomains = useProjectDomains(project);
    let [projectDomainNamesWithXmlLinks, setProjectDomainNamesWithXmlLinks] = useState(() => (
        projectIntegration === null ? value : null
    ));

    useEffect(() => {
        if (projectIntegration === null) {
            return;
        }

        new ProjectApi(authorityConfiguration)
            .hostNameAndXMLLink({
                integrationId: projectIntegration.id
            })
            .then(setProjectDomainNamesWithXmlLinks)
            .catch(() => setProjectDomainNamesWithXmlLinks([]));
    }, [project.id, projectIntegration?.id]);

    useEffect(() => {
        if (projectDomainNamesWithXmlLinks !== null) {
            onChange(projectDomainNamesWithXmlLinks);
        }
    }, [projectDomainNamesWithXmlLinks]);

    let hostNameOptions = useMemo(() => {
        if (projectDomains === null) {
            return [];
        }
        return projectDomains.map((projectDomain) => ({
            value: projectDomain.projectDomain.hostName,
            label: projectDomain.projectDomain.hostName
        }));
    }, [projectDomains]);

    return <LoadingComponent loading={projectDomainNamesWithXmlLinks === null}>
        {projectDomains === null && <Spinner/>}
        {projectDomains && <div className={'flex flex-col gap-3'}>
            {(value ?? []).map((row, index) => {
                return <div className={'rounded-xl border border-[#ddd] bg-slate-50/70 p-4 dark:border-slate-700 dark:bg-slate-900/40'} key={'xml-link-row-' + index}>
                    <div className={'mb-4 flex items-center justify-between gap-3'}>
                        <div className={'text-sm font-semibold text-slate-700 dark:text-slate-200'}>Doména a XML feed #{index + 1}</div>
                        <Button className={'!h-8 !w-8 !border-red-500 !bg-red-500 !p-0 !text-sm !text-white hover:!border-red-600 hover:!bg-red-600'} title={'Odebrat doménu'} onClick={() => onChange(value.filter((x, checkedIdx) => index !== checkedIdx))}>
                            <FontAwesomeIcon icon={faTrashCan}/>
                        </Button>
                    </div>
                    <div className={'grid gap-4'}>
                    <label className={'flex flex-col gap-1.5 text-sm font-medium text-slate-700 dark:text-slate-200'}>Doména e-shopu
                    <Creatable
                        classNamePrefix={'select'}
                        value={{label: row.hostName, value: row.hostName}}
                        onChange={(e) => {
                            value[index] = {...row, hostName: e.value};
                            onChange(value);
                        }}
                        options={hostNameOptions}
                        placeholder={'Vyberte nebo zadejte doménu'}
                    />
                    </label>
                    <label className={'flex flex-col gap-1.5 text-sm font-medium text-slate-700 dark:text-slate-200'}>URL XML feedu
                    <input
                        value={row.xmlLink}
                        className={'form-input'}
                        type={'text'}
                        onChange={(e) => {
                            value[index] = {...row, xmlLink: e.target.value};
                            onChange(value);
                        }}
                    />
                    </label>
                    </div>
                </div>;
            })}
        </div>}
        <div className={'flex justify-center pt-3'}>
            <IntegrationAddButton onClick={() => onChange([...value, {hostName: '', xmlLink: ''}])}>
                Přidat doménu
            </IntegrationAddButton>
        </div>
    </LoadingComponent>;
}
